<template>
  <div>
    <vue-table
      :showDelete="false"
      :showEdit="false"
      :tableData="spreadSheets"
      tableTitle="Tariffs"
      :fields="headers"
    ></vue-table>
    <hr>
    <div class="row">
      <div class="col-xs-12">
        <div class="pull-right">
          <parse-from-json
            :disabled="false"
            :json="spreadSheets"
            :fileName="'Rates'"
          >
          </parse-from-json>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ParseFromJson from '../../helpers/ParseFromJson'
  import VueTable from '../../helpers/VueTable'
  export default {
    name: 'Results',
    components: {
      VueTable,
      ParseFromJson
    },
    props: [
      'cartesianElements',
      'cartesianHeaders',
      'commonData',
      'woodLooseSelections',
      'containerTypeSelections'
    ],
    computed: {
      linesWithHeaders () {
        let lines = []
        this.lines.forEach(line => {
          let obj = {}
          for (let i = 0; i < line.length; i++) {
            let val = line[i]
            if (typeof val === 'object') {
              for (let prop in val) {
                obj[prop] = val[prop]
              }
            } else {
              obj[this.cartesianHeaders[i]] = line[i]
            }
          }
          lines.push(obj)
        })
        return lines
      },
      lines () {
        return this.doCartesian(...this.cartesianElements)
      },
      spreadSheets () {
        return this.linesWithHeaders.map(line => {
          return { ...line, ...this.commonData }
        })
      },
      headers () {
        let headers = []
        if (this.spreadSheets.length > 0) {
          let obj = this.spreadSheets[0]
          for (let prop in obj) {
            headers.push({
              header: prop,
              prop: prop
            })
          }
        }
        return headers
      }
    },
    methods: {
      doCartesian (a, b, ...c) {
        const f = (a, b) => [].concat(...a.map(d => b.map(e => [].concat(d, e))))
        if (b) {
          return this.doCartesian(f(a, b), ...c)
        } else if (a) {
          return a
        } else {
          return []
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// Results.vue?7205aff2